export default __webpack_public_path__ + "static/media/P1.d126e5d3.png";